module.exports = __webpack_public_path__ + "static/media/service-02.063a0b10.webm";